import { IgetChecklistEntregaObraDropDownUseCase } from "../../../presentation/useCases/read/get_checklist_entrega_obra_drop_down_use_case";
import { DropDown } from "../../models/dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * getChecklistEntregaObraDropDownUseCase
 */

export class getChecklistEntregaObraDropDownUseCase implements IgetChecklistEntregaObraDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getChecklistEntregaObraDropDown(): Promise<DropDown[]> {
    return await this.repository.getChecklistEntregaObraDropDown();

  }
}
